import { createSelector } from 'reselect/lib/index';
import availableAtDateItemsSelector from 'selectors/availableAtDateItemsSelector';

const availableItemIdsSelector = createSelector(
  [availableAtDateItemsSelector],
  items => Object.keys(items).map(v => +v),
);

export default availableItemIdsSelector;
